import { UriBuilderMatcher } from "@megaron/uri";

import { getMegaraxPath } from "./getPath";
import { MegaraxUri, MegaraxUriSchema } from "./uri";

export const megaraxWebappUrl = "https://megarax.net";

const toUrl = (path: string) => `${megaraxWebappUrl}${path}`;

const buildUri = MegaraxUri as unknown as (template: string, params?: unknown) => MegaraxUri;

export const getMegaraxUrl = Object.assign((uri: MegaraxUri) => toUrl(getMegaraxPath(uri)), {
  uri: ((...[template, params]: [keyof MegaraxUriSchema & string, unknown?]) =>
    toUrl(getMegaraxPath(buildUri(template, params)))) as UriBuilderMatcher<MegaraxUriSchema, string>,

  try: (uri: unknown) => {
    const path = getMegaraxPath.try(uri);
    return path === undefined ? undefined : toUrl(path);
  },
});
